// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Image = require("next/image").default;

var make = $$Image;

exports.make = make;
/* make Not a pure module */
